module.exports = __webpack_public_path__ + "img/Icon Popup-01.0d756533.png";